const userDataFormValidationEN = {
    "firstName": {
        "required": "First Name is required",
    },
    "lastName": {
        "required": "Last Name is required",
    },
    "personalStreet": {
        "required": "Street And Number is required",
    },
    "personalZip": {
        "required": "Zip Code is required",
    },
    "personalCity": {
        "required": "City is required",
    },
    "personalCountry": {
        "required": "Country is required",
    },
    "businessType": {
        "required": "Business Type is required",
    },
    "companyName": {
        "required": "Company Name is required",
    },
    "ceoFirstName": {
        "required": "CEO First Name is required",
    },
    "ceoLastName": {
        "required": "CEO Last Name is required",
    },
    "businessStreet": {
        "required": "Street And Number is required",
    },
    "businessZip": {
        "required": "Zip Code is required",
    },
    "businessCity": {
        "required": "City is required",
    },
    "businessCountry": {
        "required": "Country is required",
    },
    "tradeRegistryExport": {
        "file": "Please upload a valid PDF file (max size 5 MB).",
    },
    "tradeRegistryExportURL": {
        "required": "Trade Registry Export is required",
    },
    "tradeRegistryCompanyUrl": {
        "required": "Trade Registry Company URL is required",
    },
};

export default userDataFormValidationEN;